import { RHFSelect } from "src/components/hook-form";
import Map from "src/components/map";
import useAuth from "src/hooks/useAuth";
import useLocales from "src/hooks/useLocales";

/**
 * Filtro "Causale" sull'eWallet. Solo i tipi MLM realmente in uso nel
 * piano commissioni post-refactor 2026-04-29 e visibili dall'utente medio.
 *
 * Esclusi a oggi:
 *  - fund_transfer / credited_by_admin / deducted_by_admin: funzioni non in
 *    uso operativo (Giulio, 2026-05-16). Rimettere quando saranno attivate.
 *  - mother_bonus / mother_residual_bonus: per i non-summusadmin sono sempre
 *    0 record (le quote confluiscono su user_id=1), quindi inutili nel filtro.
 */
const AmountType = () => {
  const { translate } = useLocales();
  const { user } = useAuth();
  const isSummusAdmin = Number(user?.id) === 1;

  const list = isSummusAdmin ? [...options, ...motherOptions] : options;

  return (
    <RHFSelect
      name="payment_type"
      label={translate("userFinancial.eWallet.amountType")}
      size="small"
      InputLabelProps={{ shrink: true }}
    >
      <Map list={list} render={({ value, label }) => <Option value={value} label={label} />} />
    </RHFSelect>
  );
};

const Option = ({ value, label }) => {
  const { translate } = useLocales();
  return <option value={value}>{translate(label)}</option>;
};

const options = [
  { value: "",                          label: "userFinancial.eWallet.all" },
  { value: "direct_unilevel_bonus",     label: "userFinancial.eWallet.directUnilevelBonus" },
  { value: "indirect_unilevel_bonus",   label: "userFinancial.eWallet.indirectUnilevelBonus" },
  { value: "global_pool_bonus",         label: "userFinancial.eWallet.globalPoolBonus" },
];

const motherOptions = [
  { value: "mother_bonus",          label: "userFinancial.eWallet.motherBonus" },
  { value: "mother_residual_bonus", label: "userFinancial.eWallet.motherResidualBonus" },
];

export default AmountType;
